<div class="sec-title">
    <h1>Ajouter une maquette</h1>
</div>
<div><a class="btn btn-action" href="/maquettes" routerLink="/maquettes" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux maquettes</a></div>
<form class="col-8" [formGroup]="addTemplateForm" (ngSubmit)="onSubmit(addTemplateForm.value)" novalidate>
    <fieldset>
        <legend>Les détails</legend>
        <div class="fieldset-wrap">
            <div class="form-group mb-3">
                <label for="template_type" class="form-label">Type</label>
                <select class="form-select" name="template_type" id="template_type" formControlName="template_type">
                    <option *ngFor="let templateType of templatesTypes" [value]="templateType.template_type_id">
                        {{templateType.template_type_name}}
                    </option>
                </select>
            </div>

            <div class="form-group mb-3">
                <label for="template_name" class="form-label">Nom</label>
                <input type="text" class="form-control" name="template_name" id="template_name" formControlName="template_name" />
            </div>
    
            <div class="form-group mb-3">
                <label for="template_content" class="form-label">Contenu</label>
                <ckeditor name="template_content" id="template_content" formControlName="template_content"></ckeditor>
            </div>
        </div>
    </fieldset>

    <button type="submit" class="btn btn-primary">Enregistrer</button>
  
  </form>